<template>
	<router-link 
		:to="to"
		class="block px-3 py-2 text-white bg-transparent rounded-md cursor-pointer transition-colors hover:text-gray-600 hover:bg-white"
		:class="{'underline underline-offset-8 decoration-2': menuIsActive}"
  >
    <slot v-if="$slots.default"></slot>
    <template v-else>{{ name }}</template>
	</router-link>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  to: {
    type: String,
    required: true
  },
  childrenMenu: {
    type: Array,
    required: true
  },
  parent: {
    type: [Number, null],
    required: true
  }
})

const route = useRoute()

const menuIsActive = computed(() =>
    route.fullPath.includes(props.to)
    && props.to !== '/' // Ignore 'Home'
    && props.name !== 'Current Issue' // Ignore 'Current Issue'
)
</script>
